<template>
    <div class="loader-wrapper">
        <i class="fas fa-circle-notch fa-spin fa-10x"></i>
    </div>
</template>

<script>
    export default {
        name: "loader"
    }
</script>

<style scoped>
    .loader-wrapper {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
    }

    .fas {
        color: #3498db;
    }
</style>